module.exports = __webpack_public_path__ + "static/media/pinch02.b5f00893.webp";